<template>
  <div class="mall-template">
    <ul class="template-create clearfix">
      <li
        v-for="(item, index) in templates"
        :key="index"
        @click="createTemplate(item.type)">
        <a href="javascript:void(0)">
          <img :src="item.icon">
          <span>{{ item.title }}</span>
          <em>点击创建</em>
        </a>
      </li>
    </ul>

    <!-- 长页模板 -->
    <mall-dialog
      :visible="longPageCreateVisible"
      no-title
      @close="longPageCreateVisible = false">
      <iframe
        :src="`${host.client}/lg/create/page`"
        style="height: 276px;width: 600px;display:block;line-height:0;font-size:0"
        scrolling="no"
        frameborder="0"></iframe>
    </mall-dialog>

    <!-- 表单模板 -->
    <mall-dialog
      :visible="easyFormCreateVisible"
      no-title
      @close="easyFormCreateVisible = false">
      <iframe
        :src="`${host.client}/fs/create/form`"
        style="height: 480px;width: 600px;display:block;line-height:0;font-size:0"
        scrolling="no"
        frameborder="0"></iframe>
    </mall-dialog>
    <!-- 互动模板-->
    <div
      v-if="gcFormCreateVisible"
      class="gc-form-create">
      <iframe
        :src="`${host.client}/hdeip/create`"
        style="height: 100%;width: 100%;display:block;line-height:0;font-size:0;background-color: rgba(0, 0, 0, 0);"
        scrolling="no"
        frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import templateIcon from 'src/img/template-icon'
import MallDialog from 'src/components/malldialog/dialog'
import { creatScene, createH2, printSizeList } from 'src/api/templateCreate'
import { host } from 'src/config/env'
export default {
  name: 'MallTemplate',
  components: {
    MallDialog
  },
  data() {
    return {
      templates: [
        {title: 'H5模板', icon: templateIcon['h5'], type: 'h5'},
        {title: '海报模板', icon: templateIcon['h2'], type: 'h2'},
        {title: '长页模板', icon: templateIcon['h5l'], type: 'h5l'},
        {title: '视频模板', icon: templateIcon['video'], type: 'video'},
        {title: '互动模板', icon: templateIcon['gc'], type: 'gc'},
        {title: '表单模板', icon: templateIcon['h5e'], type: 'h5e'},
        {title: '功能模板', icon: templateIcon['h5t'], type: 'h5t'}
      ],
      longPageCreateVisible: false,
      easyFormCreateVisible: false,
      host,
      gcFormCreateVisible: false
    }
  },
  created() {
    window.addEventListener('message', this.onMessage)
  },
  methods: {
    createTemplate(type) {
      let newWindow = null
      let params = {}
      switch (type) {
        case 'h5':
          newWindow = window.open()
          params = {
            type: 101,
            pageMode: 0
          }
          creatScene(params).then(res => {
            newWindow.location.href = `${host.client}/c/${res.data.obj}?index=1&i=1`
          })
          break
        case 'h2':
          newWindow = window.open()
          printSizeList().then(data => {
            let result = data.data.list[0]
            let dimension = result.remark.split('*')
            params = {
              type: result.value,
              width: dimension[0],
              height: dimension[1],
              unit: 'px'
            }
            createH2(params).then(res => {
              newWindow.location.href = `${host.client}/h2/create/${res.data.obj.id}`
            })
          })
          break
        case 'h5l':
          this.longPageCreateVisible = true
          break
        case 'h5t':
          newWindow = window.open()
          params = {
            editorModel: 3,
            type: 101,
            pageMode: 0
          }
          creatScene(params).then(res => {
            newWindow.location.href = `${host.client}/c/${res.data.obj}?index=1&i=1`
          })
          break
        case 'h5e':
          this.easyFormCreateVisible = true
          break
        case 'gc':
          this.gcFormCreateVisible = true
          break
        case 'video':
          window.open(`${host.client}/video/editor/0`, '_blank')
          break
      }
    },
    onMessage(e) {
      if (e.data) {
        const msg = e.data
        msg.msgType === 'gameClose' && (this.gcFormCreateVisible = false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .mall-template {
    padding-bottom: 24px;
  }
  .template-create{
    margin-left: -6px;
    margin-right: -6px;
    li{
      width: 14.28%;
      float: left;
      padding: 0 6px;
      a{
        display: block;
        text-align: center;
        background-color: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px -2px rgba(0, 0, 0, 0.16);
        transition: all .2s linear;
        &:hover{
          box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
          transform: translate3d(0, -4px, 0);
          color: #333333;

          em {
            color: #1261FF;
            border-color: #1261FF;
          }
        }
      }
      &:first-child{
        a{
          em{
            border: 1px solid #1261FF;
            color: #1261FF;
          }
          &:hover em {
            color: #fff;
            background-color: #1261FF;
          }
        }
      }
      img{
        margin-top: 30px;
      }
      span{
        display: block;
        margin-top: 8px;
      }
      em{
        display: inline-block;
        width: 100px;
        height: 28px;
        line-height: 26px;
        border-radius: 14px;
        margin-top: 25px;
        margin-bottom: 30px;
        color: #666;
        font-size: 14px;
        border: 1px solid #CCD5DB;
      }
    }
  }
  .gc-form-create {
    position: fixed;
    left:0;
    top:0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index:999;
  }
</style>
